import { InputNumber } from 'antd';
import styled from 'styled-components';

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;
